<template>
	<div>
    <div style="height: 180px;position: relative;">
      <div class="waveWrapper waveAnimation">
        <div class="waveWrapperInner bgTop">
          <div class="wave waveTop" style=""></div>
        </div>
        <div class="waveWrapperInner bgMiddle">
          <div class="wave waveMiddle" style=""></div>
        </div>
        <div class="waveWrapperInner bgBottom">
          <div class="wave waveBottom" style=""></div>
        </div>
        <div class="theTop">
          <div class="userIcon">
            <img :src="userInfor.imgSrc"/>
          </div>
          <div class="userName">{{userInfor.name}}</div>
          <!--<div class="signature">{{userInfor.signature}}</div>-->
        </div>

      </div>
    </div>


    <div class="engineerInfor">
      <div class="inforTit">
        <div class="engineerImg"></div>
        <div>专属工程师信息</div>
      </div>
      <div class="infoCont">
        <div class="infoLabel">服务团队</div>
        <div class="information">{{engineerInfor.infor01}}</div>
      </div>
      <div class="infoCont">
        <div class="infoLabel">专属工程师</div>
        <div class="information">{{engineerInfor.infor02}}</div>
      </div>
    </div>
    <div class="serviceInfor">
      <div class="inforTit">
        <div class="serviceImg"></div>
        <div>服务信息</div>
      </div>
      <div class="infoCont" v-for="item in personalInfoList">
        <div class="infoLabel">{{item.title}}</div>
        <div class="information">{{serviceInfor[item.key]}}{{item.unit}}</div>
      </div>
    </div>
    <div class="logoutCont">
      <div class="logoutDiv" @click="logout">退出登录</div>
    </div>
  </div>
</template>
<script>
  import {_api} from '@/service/interface'
  import {MessageBox} from 'mint-ui'

  export default {
    name: 'WcMine',
    data() {
      return {
        personalInfoList: [
          {title: "远程操作命令", unit: '条', key: 'remoteOperationTimes'},
          {title: "交付件", unit: '件', key: 'deliverableTimes'},
          {title: "现场服务", unit: '次', key: 'fieldServiceTimes'},
          {title: "备件更换", unit: '次', key: 'backupChangeTimes'},
          {title: "邮件沟通", unit: '次', key: 'mailTimes'},
          {title: "电话沟通", unit: '次', key: 'phoneTimes'},
          {title: "微信沟通", unit: '次', key: 'weChatTimes'},
          {title: "诊断信息分析", unit: '项', key: 'diagnoseTimes'},
          {title: "配置合规", unit: '项', key: 'safecfgTimes'},
          {title: "技术公告扫描", unit: '项', key: 'techTimes'},
          {title: "运行状态检查", unit: '项', key: 'gatherTimes'},
          {title: "监管设备数", unit: '台', key: 'managedDeviceCount'}
        ],
        userInfor: {
          imgSrc: sessionStorage.getItem("imgUrl"),
          name: 'sherry',
          signature: ''
        },
        engineerInfor: {
          infor01: "安仔远程运维服务",
          infor02: "获取中"
        },
        serviceInfor: {
          remoteOperationTimes: 0,
          deliverableTimes: 0,
          fieldServiceTimes: 0,
          backupChangeTimes: 0,
          mailTimes: 0,
          phoneTimes: 0,
          weChatTimes: 0,
          diagnoseTimes: 0,
          safecfgTimes: 0,
          techTimes: 0,
          gatherTimes: 0,
          managedDeviceCount: 0
        }
      }
    },
    methods: {
      formatterSingature() {
        if (this.userInfor.signature == "") {
          return this.userInfor.signature = '这家伙很懒什么也没留下';
        }
      },
      getEgniner() {
        _api('_enginner', '.code', {params: {version: 2}}, res => {
          this.engineerInfor.infor02 = res.data.seatName + " " + res.data.cellphone
        }, err => {

        })
      },
      getCustomerInfo() {
        _api('_customer', '.code', {params: {mark: 'customerName'}}, res => {
          this.userInfor.name = res.data.customerCompanyName
        }, err => {

        })
      },
      getPersonalInfo() {
        _api('_personal', '.code', {params: {mark: 'serviceInfoSummary'}}, res => {
          for (let key in this.serviceInfor) {
            this.serviceInfor[key] = key == "managedDeviceCount" ? res.data.managedDeviceCount : res.data.serviceInfoVo[key]
          }
        }, err => {

        })
      },
      logout() {
        MessageBox.confirm('确定要退出登录吗？').then(action => {
          if (action == 'confirm') {
            _api('_logout', '.code', {}, res => {
              MessageBox('提示', '退出成功');
              //跳转到登陆页
              this.$router.push("/login")
            }, err => {
              MessageBox('提示', '退出失败,请重试');
            })
          }
        })
      }
    },
    mounted: function () {
      this.getEgniner();
      this.getCustomerInfo();
      this.getPersonalInfo();
      this.formatterSingature();
    }
  }
</script>

<style>
  .serviceInfor {
    margin-bottom: 5px;
  }

  .userIcon {
    width: 60px;
    height: 60px;
    border-radius: 60px;
    border: 4px solid #3BBBE2;
    background: gold;
    margin: 35px auto 10px auto;
  }

  .userIcon > img {
    width: 100%;
    height: 100%;
    border-radius: 60px;
  }

  .userName {
    text-align: center;
    color: #FFFFFF;
    font-size: 16px;
  }

  .signature {
    width: 280px;
    height: 30px;
    border-radius: 30px;
    background: #31B7D0;
    margin: 10px auto;
    color: #FFFFFF;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
  }

  .engineerInfor, .serviceInfor {
    background: #FFFFFF;
    margin-top: 10px;
  }

  .inforTit {
    color: #009CCC;
    height: 45px;
    border-bottom: 1px solid #DBDBDB;
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 15px;
  }

  .engineerImg {
    width: 17px;
    height: 20px;
    background: url(../../assets/images/engineerImg.png);
    background-size: 17px 20px;
    margin-right: 10px;
  }

  .serviceImg {
    width: 20px;
    height: 20px;
    background: url(../../assets/images/serviceImg.png);
    background-size: 20px 20px;
    margin-right: 10px;

  }

  .infoCont {
    height: 40px;
    border-bottom: 1px solid #DBDBDB;
    padding-left: 25px;
    padding-right: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .infoLabel {
    color: #7B7B7B;
    font-size: 14px;
  }

  .information {
    color: #454545;
    font-size: 14px;
  }
  .logoutDiv {
    height: 40px;
    border-bottom: 1px solid #dbdbdb;
    padding-left: 25px;
    padding-right: 25px;
    background-color: white;
    text-align: center;
    line-height: 40px;
    color: black;
    font-size: 15px;
  }
  .logoutCont{
    margin-bottom: 10px;
  }

  @keyframes move_wave {
    0% {
      transform: translateX(0) translateZ(0) scaleY(1)
    }
    50% {
      transform: translateX(-25%) translateZ(0) scaleY(0.55)
    }
    100% {
      transform: translateX(-50%) translateZ(0) scaleY(1)
    }
  }

  .waveWrapper {
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    height: 100%;
  }

  .waveWrapperInner {
    position: absolute;
    width: 100%;
    overflow: hidden;
    height: 100%;
    bottom: -1px;
    background-image: linear-gradient(left, #00B5C0, #019BCD);
    background-image: -webkit-linear-gradient(left, #00B5C0, #019BCD);
  }

  .theTop {
    position: absolute;
    width: 100%;
    overflow: hidden;
    height: 100%;
    bottom: -1px;
    z-index: 999;
  }

  .bgTop {
    z-index: 15;
    opacity: 0.5;
  }

  .bgMiddle {
    z-index: 10;
    opacity: 0.75;
  }

  .bgBottom {
    z-index: 5;
  }

  .wave {
    position: absolute;
    left: 0;
    width: 200%;
    height: 100%;
    background-repeat: repeat no-repeat;
    background-position: 0 bottom;
    transform-origin: center bottom;
  }

  .waveTop {
    background-size: 40% 40px;
    background-image: url(../../assets/images/wave-top.png);
  }

  .waveAnimation .waveTop {
    /* animation: move-wave 3s;
     -webkit-animation: move-wave 3s;
     -webkit-animation-delay: 1s;
     animation-delay: 1s; */
    animation: move_wave 5s linear infinite;
  }

  .waveMiddle {
    background-size: 40% 40px;
    background-image: url(../../assets/images/wave-mid.png)
  }

  .waveAnimation .waveMiddle {
    animation: move_wave 10s linear infinite;
  }

  .waveBottom {
    background-size: 40% 40px;
    background-image: url(../../assets/images/wave-bot.png)
  }

  .waveAnimation .waveBottom {
    animation: move_wave 10s linear infinite;

  }
</style>



// WEBPACK FOOTER //
// src/components/mine/WcMine.vue